import { render, staticRenderFns } from "./ThanksPaid.vue?vue&type=template&id=29eb7b5f&scoped=true&"
import script from "./ThanksPaid.vue?vue&type=script&lang=js&"
export * from "./ThanksPaid.vue?vue&type=script&lang=js&"
import style0 from "./ThanksPaid.vue?vue&type=style&index=0&id=29eb7b5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eb7b5f",
  null
  
)

export default component.exports